var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSelectUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9C0.5 4.30558 4.30558 0.5 9 0.5C13.6944 0.5 17.5 4.30558 17.5 9C17.5 13.6944 13.6944 17.5 9 17.5C4.30558 17.5 0.5 13.6944 0.5 9Z",
    stroke: "#CCCCCC",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.20711L11.2684 10.8536C11.4358 11.0488 11.7071 11.0488 11.8745 10.8536C12.0418 10.6583 12.0418 10.3417 11.8745 10.1464L9.30305 7.14645C9.13568 6.95118 8.86432 6.95118 8.69695 7.14645L6.12553 10.1464C5.95816 10.3417 5.95816 10.6583 6.12553 10.8536C6.29289 11.0488 6.56425 11.0488 6.73162 10.8536L9 8.20711Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_128_1098",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 6,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.20711L11.2684 10.8536C11.4358 11.0488 11.7071 11.0488 11.8745 10.8536C12.0418 10.6583 12.0418 10.3417 11.8745 10.1464L9.30305 7.14645C9.13568 6.95118 8.86432 6.95118 8.69695 7.14645L6.12553 10.1464C5.95816 10.3417 5.95816 10.6583 6.12553 10.8536C6.29289 11.0488 6.56425 11.0488 6.73162 10.8536L9 8.20711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_128_1098)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSelectUp);
export default __webpack_public_path__ + "static/media/ico-select-up.766f6081378f2ed8dbfba7617a5a347b.svg";
export { ForwardRef as ReactComponent };